import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IButtonSamplesProps extends IBaseElementProps {}

const ButtonSamples: React.FC<IButtonSamplesProps> = ({
	className,
	classNames = [],
}) => (
	<div className={className || cn('calian-button-samples', ...classNames)}>
		<div className="container-narrow my-5">
			<div className="row">
				<div className="col-12">
					<h2 className="text-center">Buttons</h2>
					<div className="container-fluid text-center my-5">
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									Light Button - Large
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a href="#/" className="btn btn-light">
									Button Text
								</a>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									Primary Button - Large
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a href="#/" className="btn btn-primary">
									Button Text
								</a>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									Dark Button - Large
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a href="#/" className="btn btn-dark">
									Button Text
								</a>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									ITCS-primary Button - Large
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a href="#/" className="btn btn-itcs-primary">
									Button Text
								</a>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									ITCS-accent Button - Large
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a href="#/" className="btn btn-itcs-accent">
									Button Text
								</a>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									Light Button - Small
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a href="#/" className="btn btn-sm btn-light">
									Button Text
								</a>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									Primary Button - Small
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a href="#/" className="btn btn-sm btn-primary">
									Button Text
								</a>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									Dark Button - Small
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a href="#/" className="btn btn-sm btn-dark">
									Button Text
								</a>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									ITCS-primary Button - Small
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a
									href="#/"
									className="btn btn-sm btn-itcs-primary"
								>
									Button Text
								</a>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-12 col-md-6">
								<p className="mb-0 h-100 d-flex justify-content-center align-items-center">
									ITCS-accent Button - Small
								</p>{' '}
							</div>
							<div className="col-12 col-md-6">
								<a
									href="#/"
									className="btn btn-sm btn-itcs-accent"
								>
									Button Text
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default ButtonSamples;
